import { render } from "./PageScroller.vue?vue&type=template&id=801953ba"
import script from "./PageScroller.vue?vue&type=script&lang=js"
export * from "./PageScroller.vue?vue&type=script&lang=js"

import "./PageScroller.vue?vue&type=style&index=0&id=801953ba&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__